// Hide sticky bar when scrolled near footer (cards section / footer)
(function(){
  function check(){
    const bar = document.getElementById('ArtopStickyBar');
    if (!bar) return;
    const footer = document.querySelector('footer, .footer, .artop-others, #artop-recent');
    if (!footer) return;
    const fr = footer.getBoundingClientRect();
    if (fr.top < window.innerHeight + 100) bar.classList.add('is-hidden-near-footer');
    else bar.classList.remove('is-hidden-near-footer');
  }
  window.addEventListener('scroll', check, { passive: true });
  window.addEventListener('resize', check);
  setTimeout(check, 500);
})();
